module.exports = __webpack_public_path__ + "img/GS_Profiles-Lerato Patience Lekalakala.bb4ec684.png";